"use strict";

var cov_1vmxtdli8s = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\chapters\\Chapter.js";
  var hash = "012107cc4eb62ceb7dae5f314f951b49e7ebc19e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\chapters\\Chapter.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 23
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "2": {
        start: {
          line: 24,
          column: 30
        },
        end: {
          line: 24,
          column: 55
        }
      },
      "3": {
        start: {
          line: 26,
          column: 23
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "4": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 35
        }
      },
      "5": {
        start: {
          line: 27,
          column: 19
        },
        end: {
          line: 27,
          column: 35
        }
      },
      "6": {
        start: {
          line: 29,
          column: 17
        },
        end: {
          line: 29,
          column: 49
        }
      },
      "7": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 34,
          column: 7
        }
      },
      "8": {
        start: {
          line: 36,
          column: 30
        },
        end: {
          line: 36,
          column: 48
        }
      },
      "9": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 51,
          column: 96
        }
      },
      "10": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      "11": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 47,
          column: 10
        }
      },
      "12": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 25
        }
      },
      "13": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 58,
          column: 4
        }
      },
      "14": {
        start: {
          line: 61,
          column: 0
        },
        end: {
          line: 74,
          column: 2
        }
      },
      "15": {
        start: {
          line: 76,
          column: 18
        },
        end: {
          line: 79,
          column: 3
        }
      },
      "16": {
        start: {
          line: 76,
          column: 39
        },
        end: {
          line: 79,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 23
          },
          end: {
            line: 14,
            column: 24
          }
        },
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 23
          },
          end: {
            line: 26,
            column: 24
          }
        },
        loc: {
          start: {
            line: 26,
            column: 38
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 12
          },
          end: {
            line: 38,
            column: 13
          }
        },
        loc: {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 51,
            column: 3
          }
        },
        line: 38
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 29
          },
          end: {
            line: 76,
            column: 30
          }
        },
        loc: {
          start: {
            line: 76,
            column: 39
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 76
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 35
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 35
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }],
        line: 39
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "012107cc4eb62ceb7dae5f314f951b49e7ebc19e"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Chapter = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _lab = require("@material-ui/lab");

var _reactWaypoint = require("react-waypoint");

var _Verses = require("../verses/Verses");

cov_1vmxtdli8s.s[0]++;

var Chapter = function Chapter(_ref) {
  var chapterKey = _ref.chapterKey,
      chapter = _ref.chapter,
      paragraphs = _ref.paragraphs,
      renderOffscreen = _ref.renderOffscreen,
      showUnsupported = _ref.showUnsupported,
      direction = _ref.direction,
      disableWordPopover = _ref.disableWordPopover;
  cov_1vmxtdli8s.f[0]++;
  var classes = (cov_1vmxtdli8s.s[1]++, useStyles());

  var _ref2 = (cov_1vmxtdli8s.s[2]++, (0, _react.useState)(renderOffscreen)),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      viewed = _ref3[0],
      setViewed = _ref3[1];

  cov_1vmxtdli8s.s[3]++;

  var onVisibility = function onVisibility(isVisible) {
    cov_1vmxtdli8s.f[1]++;
    cov_1vmxtdli8s.s[4]++;

    if (isVisible) {
      cov_1vmxtdli8s.b[0][0]++;
      cov_1vmxtdli8s.s[5]++;
      setViewed(true);
    } else {
      cov_1vmxtdli8s.b[0][1]++;
    }
  };

  var height = (cov_1vmxtdli8s.s[6]++, Object.keys(chapter).length * 20);
  var skeleton = (cov_1vmxtdli8s.s[7]++, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactWaypoint.Waypoint, {
    onEnter: onVisibility
  }), _react.default.createElement(_lab.Skeleton, {
    height: height,
    width: "100%",
    className: classes.skeleton
  })));

  var _ref4 = (cov_1vmxtdli8s.s[8]++, (0, _react.useState)(skeleton)),
      _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      verses = _ref5[0],
      setVerses = _ref5[1];

  cov_1vmxtdli8s.s[9]++;
  (0, _react.useEffect)(function () {
    cov_1vmxtdli8s.f[2]++;
    cov_1vmxtdli8s.s[10]++;

    if (viewed) {
      cov_1vmxtdli8s.b[1][0]++;

      var _verses = (cov_1vmxtdli8s.s[11]++, _react.default.createElement(_Verses.Verses, {
        verses: chapter,
        paragraphs: paragraphs,
        showUnsupported: showUnsupported,
        direction: direction,
        disableWordPopover: disableWordPopover
      }));

      cov_1vmxtdli8s.s[12]++;
      setVerses(_verses);
    } else {
      cov_1vmxtdli8s.b[1][1]++;
    }
  }, [chapterKey, chapter, paragraphs, viewed, showUnsupported, disableWordPopover, direction]);
  cov_1vmxtdli8s.s[13]++;
  return _react.default.createElement("div", {
    className: classes.chapter,
    dir: direction
  }, _react.default.createElement(_core.Typography, {
    variant: "h3"
  }, chapterKey), verses);
};

exports.Chapter = Chapter;
cov_1vmxtdli8s.s[14]++;
Chapter.propTypes = {
  chapterKey: _propTypes.default.string.isRequired,
  chapter: _propTypes.default.object.isRequired,

  /** render verses paragraphs, use explicit paragraphs */
  paragraphs: _propTypes.default.bool,

  /** bypass rendering only when visible */
  renderOffscreen: _propTypes.default.bool,

  /** render unsupported usfm markers */
  showUnsupported: _propTypes.default.bool,

  /** override text direction detection */
  direction: _propTypes.default.string,

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool
};
var useStyles = (cov_1vmxtdli8s.s[15]++, (0, _styles.makeStyles)(function (theme) {
  cov_1vmxtdli8s.f[3]++;
  cov_1vmxtdli8s.s[16]++;
  return {
    chapter: {}
  };
}));
var _default = Chapter;
exports.default = _default;